export default (props, vars) =>
  vars?.['useform2']?.['register']('checkbox_not_guarantee_job', {
    required: true,
  });
